import authenticationAPI from "@/api/authentication";
import usersAPI from "@/api/users";

import Router, { NavigationGuardNext, Route } from "vue-router";


export async function userLogin(router: Router) {
	window.location.href = await authenticationAPI.userLogin();
}

export async function logout() {
	await authenticationAPI.logout();
	window.location.href = "/";
}

export async function userDiscordLogin(router: Router) {
	window.location.href = await authenticationAPI.userDiscordLogin();
}

export async function discordDisconnect() {
	await authenticationAPI.discordDisconnect();
	window.location.reload();
}


export function requireAuth() {
	return async (to: Route, from: Route, next: NavigationGuardNext) => {
		let query = {};
		if (to.path != "/") {
			query = {redirect: to.path};
		}

		try {
			const currentUser = await usersAPI.getDetails();
			if (!currentUser) {
				return next({
					path: "/login",
					query: query
				});
			}
			to.meta.userProfile = currentUser;
		} catch (error) {
			return next({
				path: "/"
			});
		}

		if (to.query.redirect) {
			return next({
				path: to.query.redirect as string
			});
		}
		return next();

	};
}
